// import downArrow from '../../../assets/images/downArrow.svg'
// import ReactReadMoreReadLess from 'react-read-more-read-less'
import { useState } from 'react'
import ReactMoreReadLess from '../../common/ReadMoreReadLess/ReactMoreReadLess'
import ViewAll from '../ViewAll'
import ExpandDetail from './ExpandDetail'

const AtAGlanceLayout = ({ layout, value, handleDetailPageClose }) => {
  console.log('>>>value:::', value)
  // dialogues box
  const [open, setOpen] = useState(false)

  const handleExpandPageOpen = () => {
    setOpen(true)
  }

  const handleExpandPageClose = () => {
    setOpen(false)
  }
  //----

  return (
    <div
      style={{
        padding: '24px 20px 24px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#f0f000',
      }}
    >
      {layout.display_name && (
        <div
          style={{
            marginTop: '10px',
            marginBottom: '8px',
            textAlign: 'left',
            color: 'var(--gray100)',
            listStyle: 'none',
          }}
        >
          <p className="title2">{layout.display_name}</p>
          {value.rating !== 0 && value.rating && (
            <p className="body2" style={{ color: 'var(--grey100)' }}>
              {value.rating + '-star property'}
            </p>
          )}
        </div>
      )}
      <div
        style={{
          textAlign: 'left',
          color: 'var(--gray80)',
        }}
      >
        <pre
          className="body2"
          style={{ whiteSpace: 'pre-line', lineHeight: '150%' }}
        >
          {layout.name === 'about_the_attraction' && (
            <ReactMoreReadLess
              moreText={'More'}
              lessText={'Less'}
              showArrow={true}
              lines={'3'}
              top={'8px'}
            >
              {value.desc}
            </ReactMoreReadLess>
          )}
          {layout.name === 'about_the_hotel' && (
            <>
              <ReactMoreReadLess
                moreText={'View all'}
                lessText={'View few'}
                showArrow={true}
                lines={'3'}
                top={'8px'}
                isExpand={true}
                isCustomIcon={true}
                handlerFunction={handleExpandPageOpen}
              >
                {value.desc}
              </ReactMoreReadLess>
              {/* <ViewAll>View all</ViewAll> */}
              {/* <button
                onClick={(e) => {
                  e.preventDefault()
                  handleExpandPageOpen()
                }}
              >
                open dialog
              </button> */}
              <ExpandDetail
                open={open}
                handleExpandPageClose={handleExpandPageClose}
                handleDetailPageClose={handleDetailPageClose}
                value={value.desc}
                layout={layout}
                contentType={'about_hotel'}
              />
            </>
          )}

          {layout.name === 'about_the_activity' && (
            <>
              <ReactMoreReadLess
                moreText={'More'}
                lessText={'Less'}
                showArrow={true}
                lines={'4'}
                top={'8px'}
                addNewLines={0}
              >
                {value.desc}
              </ReactMoreReadLess>
            </>
          )}
        </pre>
      </div>

      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingTop: "4px",
        }}
      >
        <button
          style={{
            fontWeight: 590,
            fontSize: "15px",
            lineHeight: "150%",
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            letterSpacing: "-0.005em",
            color: "#00857D",
            border: "none",
            background: "white",
            paddingRight: 0,
            paddingLeft: 0,
          }}
        >
          More
        </button>
        <img
          src={downArrow}
          alt=""
          style={{
            fontWeight: 590,
            fontSize: "15px",
            lineHeight: "150%",
          }}
        ></img>
      </div> */}
    </div>
  )
}

export default AtAGlanceLayout
